import type { enAdmin } from "./en.admin";

/** Russian for the settings and admin screens (see `en.admin.ts`). */
export const ruAdmin: Record<keyof typeof enAdmin, string> = {
  "ws.saved": "Настройки сохранены",
  "ws.saveFailed": "Не удалось сохранить",
  "ws.loading": "Загружаем рабочее пространство…",
  "ws.title": "Рабочее пространство",
  "ws.subtitle": "Название и настройки по умолчанию — общие для всех в этом пространстве.",
  "ws.name": "Название",
  "ws.people": "Люди и роли",
  "ws.people.hint": "Кто работает в трекере и с какой ролью: Админ, Байер или Наблюдатель. Роли выдают владелец и админы организации в консоли.",
  "ws.people.open": "Участники и роли",
  "ws.domain": "Трекинговый домен по умолчанию",
  "ws.domain.hint": "Новые кампании берут этот домен для своих ссылок /clk.",
  "ws.preset": "Пресет по умолчанию",
  "ws.preset.hint": "Какие системные отчёты и цели получает пространство по умолчанию.",
  "ws.preset.none": "Без пресета",
  "ws.tz": "Часовой пояс",
  "ws.tz.hint": "Все отчёты считают дни в этом поясе, если на странице не выбран другой; лид остаётся в том дне, когда пришёл.",
  "ws.slug": "Код",
  "ws.status": "Статус",
  "ws.org": "Организация в Keycloak",
  "ws.save": "Сохранить",
  "ws.readOnly": "У вас доступ только на чтение — изменить настройки может администратор.",
  "ws.status.active": "Активно",
  "ws.status.suspended": "Приостановлено",
  "ws.status.archived": "В архиве",
  "audit.kind.workspace": "Пространство",
  "audit.kind.trafficSource": "Источник",
  "audit.kind.network": "Партнёрка",
  "audit.kind.offer": "Оффер",
  "audit.kind.lander": "Ленд",
  "audit.kind.campaign": "Кампания",
  "audit.kind.flow": "Поток",
  "audit.kind.flowTemplate": "Шаблон потока",
  "audit.kind.domain": "Домен",
  "audit.kind.integration": "Интеграция",
  "audit.kind.snippet": "Сниппет тег-менеджера",
  "audit.kind.alertRule": "Правило оповещения",
  "audit.kind.rule": "Правило",
  "audit.kind.contentSet": "Набор контента",
  "audit.verb.create": "создание",
  "audit.verb.update": "изменение",
  "audit.verb.pause": "пауза",
  "audit.verb.activate": "включение",
  "audit.verb.archive": "архив",
  "audit.verb.duplicate": "копирование",
  "audit.verb.delete": "удаление",
  "logs.col.time": "Время",
  "logs.col.actor": "Кто",
  "logs.col.action": "Действие",
  "logs.col.resource": "Объект",
  "logs.system": "система",
  "logs.title": "История изменений",
  "logs.subtitle": "Все изменения в пространстве: кто, что и когда. Записи не правятся и не удаляются.",
  "logs.error": "Не удалось загрузить историю",
  "logs.allResources": "Все объекты",
  "logs.filter.actor": "Фильтр по человеку",
  "logs.filter.actor.ph": "ID человека…",
  "logs.filter.action": "Фильтр по действию",
  "logs.filter.action.ph": "Действие (campaign.update)…",
  "logs.empty": "За выбранный период изменений нет.",
  "logs.detail": "Изменение",
  "logs.detail.hint": "Выберите строку — покажем, кто что изменил и как было до и после.",
  "logs.by": "Кто",
  "logs.changes": "Что изменилось",
  "logs.noDiff": "Состояние до и после не записано.",
  "logs.requestId": "ID запроса",
  "logs.ua": "Браузер",
  "rules.domain.click": "Маршрутизация",
  "rules.domain.metrics": "Оповещение",
  "rules.sev.info": "Инфо",
  "rules.sev.warning": "Внимание",
  "rules.sev.critical": "Критично",
  "rules.ago.now": "только что",
  "rules.ago.m": "{n} мин назад",
  "rules.ago.h": "{n} ч назад",
  "rules.ago.d": "{n} дн назад",
  "rules.ago.mo": "{n} мес назад",
  "rules.act.none": "Без действия",
  "rules.act.route.offer": "оффер",
  "rules.act.route.lander": "ленд",
  "rules.act.route.default": "по умолчанию",
  "rules.act.route": "Направить → {target}",
  "rules.act.block": "Блокировать",
  "rules.act.notify": "Оповестить ({n})",
  "rules.event.observed": "факт {observed} · порог {threshold}",
  "rules.title": "Правила",
  "rules.subtitle": "Одна модель, два применения: правила маршрутизации решают, куда пойдёт клик в потоке; оповещения следят за цифрами и присылают сообщение.",
  "rules.tab.library": "Библиотека",
  "rules.tab.events": "Сработавшие оповещения",
  "rules.search": "Поиск правил по названию…",
  "rules.new": "Новое правило",
  "rules.loadError": "Не удалось загрузить правила",
  "rules.filter.all": "Все правила",
  "rules.filter.click": "Маршрутизация",
  "rules.filter.metrics": "Оповещения",
  "rules.tags": "Теги",
  "rules.toast.on": "«{name}» включено",
  "rules.toast.off": "«{name}» выключено",
  "rules.updateFailed": "Не удалось сохранить",
  "rules.untitled": "Правило без названия",
  "rules.on": "Вкл",
  "rules.off": "Выкл",
  "rules.toggle": "Включить или выключить «{name}»",
  "rules.usedIn": "Используется в",
  "rules.noMatch": "Под этот фильтр правил нет.",
  "rules.empty.title": "Создайте первое правило",
  "rules.empty.body": "Правила переиспользуются. Сделайте фильтр маршрутизации для веток потока или оповещение, которое следит за метрикой в окне. Начните с шаблона:",
  "rules.empty.routing": "Фильтр маршрутизации",
  "rules.empty.alert": "Оповещение по метрике",
  "rules.col.severity": "Важность",
  "rules.col.triggered": "Сработало",
  "rules.col.rule": "Правило",
  "rules.col.summary": "Суть",
  "rules.col.ack": "Принято",
  "rules.acked": "принято",
  "rules.ackFailed": "Не удалось отметить",
  "rules.ack": "Принять",
  "rules.events.loadError": "Не удалось загрузить оповещения",
  "rules.events.unacked": "Только непринятые",
  "rules.events.allClear": "Непринятых оповещений нет.",
  "rules.events.none": "Оповещения ещё не срабатывали.",
  "rule.ed.nameRequired": "Укажите название",
  "rule.ed.updated": "Правило сохранено",
  "rule.ed.created": "Правило создано",
  "rule.ed.saveFailed": "Не удалось сохранить",
  "rule.ed.usedDetach": "Используется в потоках: {n} — сначала отвяжите",
  "rule.ed.confirmDelete": "Удалить правило «{name}»? Прошлые срабатывания останутся в журнале.",
  "rule.ed.deleted": "Правило удалено",
  "rule.ed.deleteFailed": "Не удалось удалить",
  "rule.ed.edit": "Правило",
  "rule.ed.desc": "Условие и что делать, когда оно выполнено. Маршрутизация выбирает ветку потока для клика; оповещение присылает сообщение, когда метрика переходит порог.",
  "rule.ed.save": "Сохранить",
  "rule.ed.create": "Создать",
  "rule.ed.cancel": "Отмена",
  "rule.ed.delete": "Удалить",
  "rule.ed.name": "Название",
  "rule.ed.name.ph.metrics": "Контроль CPA — US нутра",
  "rule.ed.name.ph.click": "Блок ботов — десктоп",
  "rule.ed.kind": "Тип",
  "rule.ed.description": "Описание",
  "rule.ed.description.ph": "Для чего это правило (необязательно).",
  "rule.ed.condition": "Условие",
  "rule.ed.usedBy": "Используется в потоках: {n} — удалить можно только после отвязки.",
  "rule.ai.none": "Помощник не предложил правило — переформулируйте",
  "rule.ai.drafted": "Черновик правила готов",
  "rule.ai.review": "Черновик нужно проверить",
  "rule.ai.connect": "Чтобы пользоваться помощником, подключите {provider}",
  "rule.ai.failed": "Не удалось предложить правило",
  "rule.ai.ph.metrics": "Опишите оповещение… например, «предупреди, если расход вырос на 50% за час»",
  "rule.ai.ph.click": "Опишите правило… например, «мобильный трафик US/CA без ботов»",
  "rule.ai.drafting": "Составляю…",
  "rule.ai.draft": "Составить",
  "rule.act.channelType": "Тип канала",
  "rule.act.removeChannel": "Убрать канал",
  "rule.act.addChannel": "Добавить канал",
  "rule.act.legend": "Действие (необязательно)",
  "rule.act.hint": "Правило маршрутизации обычно выбирает ветку потока там, где на него ссылаются. Явное действие «направить» или «блокировать» заменяет назначение, когда правило срабатывает.",
  "rule.act.kind": "Действие",
  "rule.act.kind.none": "Без действия (только условие)",
  "rule.act.kind.route": "Направить в…",
  "rule.act.blockReason": "Причина блокировки",
  "rule.act.blockReason.ph": "Боты",
  "cond.metric": "Метрика",
  "cond.expand": "Развернуть группу",
  "cond.collapse": "Свернуть группу",
  "cond.and": "И",
  "cond.or": "ИЛИ",
  "cond.emptyGroup": "Группа пуста. Добавьте условие ниже.",
  "cond.remove": "Убрать условие",
  "cond.addCondition": "Условие",
  "cond.addGroup": "Группа",
  "cond.notHint": "Обращает вложенное условие.",
  "cond.sec.logic": "Логика",
  "cond.sec.audience": "Аудитория",
  "cond.sec.request": "Запрос",
  "cond.sec.signals": "Сигналы",
  "cond.sec.power": "Для опытных",
  "cond.removeValue": "Убрать {v}",
  "cond.f.groupAnd": "Все (И)",
  "cond.f.groupAnd.hint": "Выполнены все вложенные",
  "cond.f.groupOr": "Любое (ИЛИ)",
  "cond.f.groupOr.hint": "Выполнено хотя бы одно вложенное",
  "cond.f.not": "Не",
  "cond.f.not.hint": "Обратить вложенное условие",
  "cond.f.all": "Всегда",
  "cond.f.all.hint": "Всегда истинно",
  "cond.f.country": "Страна",
  "cond.f.country.hint": "Коды ISO-3166 alpha-2",
  "cond.f.language": "Язык",
  "cond.f.language.hint": "Основной тег Accept-Language",
  "cond.f.device": "Устройство",
  "cond.f.device.hint": "mobile / tablet / desktop",
  "cond.f.match": "Поле визита",
  "cond.f.match.hint": "регион, город, провайдер, ОС, браузер, IP, UA, реферер…",
  "cond.f.urlParam": "Параметр URL",
  "cond.f.urlParam.hint": "?name=value",
  "cond.f.header": "Заголовок запроса",
  "cond.f.header.hint": "имя: значение",
  "cond.f.botScore": "Бот-скор",
  "cond.f.botScore.hint": "0–100, со сравнением",
  "cond.f.timeOfDay": "Время суток",
  "cond.f.timeOfDay.hint": "Часы по UTC",
  "cond.f.weightSplit": "Доля трафика",
  "cond.f.weightSplit.hint": "Детерминированная доля посетителей",
  "cond.f.expression": "Выражение",
  "cond.f.expression.hint": "Свободное выражение expr-lang",
  "cond.f.botSignal": "Бот-сигнал",
  "cond.f.botSignal.hint": "Датацентр / Tor / VPN / аномалия",
  "cond.f.spendSpike": "Скачок расхода",
  "cond.f.spendSpike.hint": "рост в % к базе",
  "cond.f.conversionDrop": "Падение конверсий",
  "cond.f.conversionDrop.hint": "падение в % к базе",
  "cond.f.roiBelow": "ROI ниже",
  "cond.f.roiBelow.hint": "нижняя граница",
  "cond.f.zeroConversions": "Ноль конверсий",
  "cond.f.zeroConversions.hint": "нет конверсий в окне",
  "cond.f.cpaAbove": "CPA выше",
  "cond.f.cpaAbove.hint": "потолок цены лида",
  "cond.op.eq": "= равно",
  "cond.op.lt": "< меньше",
  "cond.op.lte": "≤ не больше",
  "cond.op.gt": "> больше",
  "cond.op.gte": "≥ не меньше",
  "cond.sig.bot": "Общий признак бота",
  "cond.sig.dc": "IP датацентра",
  "cond.sig.tor": "Выход Tor",
  "cond.sig.vpn": "Известный VPN",
  "cond.sig.ua": "Аномалия User-Agent",
  "cond.m.spendSpike.help": "Срабатывает, когда расход вырос минимум на столько процентов к периоду сравнения.",
  "cond.m.conversionDrop.help": "Срабатывает, когда конверсии упали минимум на столько процентов к периоду сравнения.",
  "cond.m.roiBelow.help": "Срабатывает, когда ROI за окно опускается ниже этого значения.",
  "cond.m.zeroConversions.help": "Срабатывает, когда за окно был трафик, но ни одной конверсии. Без порога.",
  "cond.m.cpaAbove.help": "Срабатывает, когда цена лида за окно превышает эту сумму.",
  "cond.expected": "Ожидаемое значение",
  "cond.threshold": "Порог",
  "cond.threshold.none": "нет — только окно",
  "cond.window": "Окно (минуты)",
  "cond.compare": "С чем сравнивать",
  "cond.compare.day": "Предыдущий день",
  "cond.compare.week": "Предыдущая неделя",
  "cond.windowOf": "окно {w}",
  "cond.s.negated": "отрицание",
  "cond.s.always": "всегда",
  "cond.all.body": "Всегда истинно. Удобно как заготовка.",
  "cond.s.noCountries": "страны не выбраны",
  "cond.country.codes": "Коды стран ISO",
  "cond.s.noLanguages": "языки не выбраны",
  "cond.language.tags": "Языки",
  "cond.s.noDevices": "устройства не выбраны",
  "cond.device.kinds": "Типы устройств",
  "cond.s.noName": "без имени",
  "cond.param.name": "Имя параметра",
  "cond.s.noHeader": "заголовок не задан",
  "cond.header.name": "Имя заголовка",
  "cond.s.ranges": "диапазонов: {n}",
  "cond.operator": "Сравнение",
  "cond.match.field": "Поле",
  "cond.match.values": "Значения",
  "cond.threshold100": "Порог (0–100)",
  "cond.hourStart": "С часа (UTC)",
  "cond.hourEnd": "До часа (UTC)",
  "cond.s.bucket": "доля {n}%",
  "cond.bucket": "Доля (0–100%)",
  "cond.bucket.hint": "ID посетителя хэшируется детерминированно; правило срабатывает для первых weight% корзин.",
  "cond.s.noExpression": "выражения нет",
  "cond.expr.label": "Выражение (expr-lang)",
  "cond.expr.hint": "Для редких случаев, которые не выразить готовыми условиями. По возможности используйте их.",
  "cond.signal": "Сигнал",
  "cond.signal.hint": "Срабатывает, когда у запроса есть этот бот-сигнал.",
  "cond.sum.spend": "Расход",
  "cond.sum.conversions": "Конверсии",
  "cond.sum.not": "НЕ",
  "cond.sum.country": "страна",
  "cond.sum.lang": "язык",
  "cond.sum.device": "устройство",
  "flows.mode.single": "Один оффер",
  "flows.mode.split": "Сплит",
  "flows.mode.weighted": "Ротация по весам",
  "flows.mode.rules": "По правилам",
  "flows.mode.template": "Из шаблона",
  "flows.col.name": "Название",
  "flows.col.mode": "Режим",
  "flows.col.nodes": "Узлы",
  "flows.nodesEdges": "{nodes} узл. / {edges} связей",
  "flows.col.actions": "Действия",
  "flows.edit": "Изменить",
  "flows.archived": "Поток в архиве",
  "flows.archiveFailed": "Не удалось архивировать",
  "flows.archive": "В архив",
  "flows.title": "Потоки",
  "flows.subtitle": "Графы маршрутизации. Кампания привязана к одному потоку; по нему роутер выбирает ленд и оффер для клика.",
  "flows.new": "Новый поток",
  "flows.loadError": "Не удалось загрузить потоки",
  "flows.search": "Поиск потоков",
  "flows.search.ph": "Поиск потоков…",
  "flows.empty.title": "Потоков пока нет",
  "flows.empty.body": "Возьмите шаблон потока с готовым рецептом (офферы по гео, A/B-сплит лендов, защита от ботов…) или соберите с нуля.",
  "flows.empty.templates": "Шаблоны потоков",
  "flows.empty.blank": "Пустой поток",
  "flows.noMatch": "По запросу потоков нет.",
  "node.lander": "Ленд",
  "node.lander.desc": "Показать ленд или прелендинг перед оффером.",
  "node.offer": "Оффер",
  "node.offer.desc": "Отправить клик на ссылку оффера.",
  "node.network": "Партнёрка",
  "node.network.desc": "Передать клик на смартлинк партнёрки.",
  "node.filter": "Фильтр",
  "node.filter.desc": "Пропускает дальше по условию (выражение CEL).",
  "node.redirect": "Редирект",
  "node.redirect.desc": "Отправить посетителя на любой адрес.",
  "node.branch": "Ветка",
  "node.branch.desc": "Второй вход: куда идёт посетитель по «Назад», при попытке уйти, бездействии или в конце страницы. Момент ловит страница; соедините ветку с её лендами или офферами.",
  "node.botRule": "Правило ботов",
  "node.botRule.desc": "Отсекает ботов до оффера.",
  "node.safePage": "Белая страница",
  "node.safePage.desc": "Конечный узел: отдаёт безопасную страницу клоаки. Отдельно от редиректа, чтобы в аналитике отличать попадания клоаки от денежных 302.",
  "node.jsChallenge": "JS-проверка",
  "node.jsChallenge.desc": "Промежуточная страница с проверкой JS, canvas и времени; прошедший получает подписанную куку и возвращается в поток. Headless-скраперы дальше не проходят.",
  "node.fpGate": "Проверка отпечатка",
  "node.fpGate.desc": "Скоринг клоаки по нескольким сигналам: TLS JA4, User-Agent и заголовки дают балл; низкий и средний идут дальше по потоку, высокий — на белую страницу.",
  "node.unknown": "Неизвестно",
  "node.role.pre": "Прелендинг",
  "node.role.pre.hint": "Прогревающая страница перед основным лендом.",
  "node.role.landing": "Ленд",
  "node.role.landing.hint": "Основная страница с призывом к действию.",
  "node.role.thanks": "Спасибо",
  "node.role.thanks.hint": "Страница подтверждения после конверсии.",
  "node.branch.noTrigger": "триггер не выбран",
  "node.branch.idle": "{label} · {n} с",
  "palette.pages": "Страницы",
  "palette.logic": "Логика",
  "palette.exits": "Выходы",
  "palette.branches": "Ветки",
  "palette.add": "Добавить узел",
  "palette.search": "Поиск узлов…",
  "palette.search.label": "Поиск типов узлов",
  "palette.noMatch": "Узлов по «{q}» нет.",
  "palette.dragHint": "Нажмите, чтобы добавить, или перетащите на холст",
  "insp.title": "Свойства",
  "insp.empty": "Выберите узел на холсте, чтобы изменить его свойства.",
  "insp.node": "Узел",
  "insp.terminal": "конечный",
  "insp.start": "старт",
  "insp.close": "Закрыть свойства",
  "insp.tab": "Вкладка",
  "insp.tab.config": "Настройки",
  "insp.tab.context": "Контекст",
  "insp.tab.rules": "Правила",
  "insp.makeStart": "Сделать стартовым узлом",
  "insp.nodeContext": "Контекст узла",
  "insp.remove": "Удалить",
  "insp.done": "Готово",
  "insp.lander.hint": "Выберите ленд или сошлитесь на параметр как ${name}.",
  "insp.role": "Роль в воронке",
  "insp.role.hint": "Подписывает шаг в воронке кампании (прелендинг → ленд → спасибо). Только подпись — на маршрутизацию не влияет.",
  "insp.offer.hint": "Выберите оффер или сошлитесь на параметр как ${name}.",
  "insp.network": "ID партнёрки",
  "insp.network.hint": "UUID партнёрки или ${param}.",
  "insp.redirect": "Адрес редиректа",
  "insp.trigger": "Триггер",
  "insp.trigger.hint": "Момент ловит страница и отправляет посетителя сюда. Одна ветка на триггер.",
  "insp.trigger.ph": "Выберите триггер",
  "insp.idle": "Секунды бездействия",
  "insp.idle.hint": "Сколько секунд без действий ({min}–{max}).",
  "insp.safeUrl": "Адрес белой страницы",
  "insp.cookie": "Имя куки прохода",
  "insp.cookie.hint": "Ставится /jsc/verify, когда посетитель прошёл проверку. Если проверок в потоке несколько — задайте разные имена.",
  "insp.cookieTtl": "Срок куки прохода (с)",
  "insp.cookieTtl.hint": "0 — значение сервера по умолчанию (1800 с).",
  "insp.sort": "Порядок",
  "insp.weight": "Вес",
  "insp.weight.typed": "Используется для вероятностного сплита, когда узел — одна из нескольких целей.",
  "insp.weight.other": "0–100. Ротатор делит трафик по весам целей.",
  "insp.enabled": "Включён",
  "insp.fp.hint": "Веса сигналов независимы (это не распределение). Оставьте 0 — сервер возьмёт значения по умолчанию: поровну, границы 0,33 / 0,66.",
  "insp.fp.ja4": "Вес JA4",
  "insp.fp.ua": "Вес UA",
  "insp.fp.header": "Вес заголовков",
  "insp.fp.low": "Нижний порог",
  "insp.fp.low.hint": "Балл ниже ⇒ низкая зона (идёт дальше).",
  "insp.fp.high": "Верхний порог",
  "insp.fp.high.hint": "Балл не ниже ⇒ высокая зона (белая страница).",
  "insp.rules.bot": "Бот-сигналы срабатывают до конечного узла. Попадание сразу уходит в редирект.",
  "insp.rules.filter": "Условие решает, по каким связям может пойти клик. Комбинируйте группы И/ИЛИ/НЕ.",
  "insp.param": "Привязка к параметру",
  "insp.clear": "Очистить",
  "insp.newParam": "+ новый параметр",
  "insp.sum": "Σ {sum}/100 на {n} соседних",
  "insp.autoDistribute": "Поровну",
  "tpl.scope.ws": "Пространство",
  "tpl.scope.ws.hint": "Видно только вашему пространству.",
  "tpl.scope.org": "Организация",
  "tpl.scope.org.hint": "Доступно всем пространствам организации.",
  "tpl.scope.global": "Общий",
  "tpl.scope.global.hint": "Показывается в галерее всем.",
  "bp.fromFlow.name": "{name} (шаблон)",
  "bp.fromFlow.desc": "Снято с потока {id}",
  "bp.nameRequired.tpl": "Укажите название шаблона",
  "bp.nameRequired.flow": "Укажите название потока",
  "bp.needNode": "Добавьте хотя бы один узел",
  "bp.fixErrors": "Исправьте ошибки перед сохранением",
  "bp.tplUpdated.rerouted": "Шаблон сохранён — пересобрано кампаний: {n}",
  "bp.tplUpdated": "Шаблон сохранён",
  "bp.keptRouting": "Кампания осталась на прежней маршрутизации: {message}",
  "bp.tplCreated": "Шаблон создан",
  "bp.flowSaved": "Поток сохранён",
  "bp.flowCreated": "Поток создан",
  "bp.back.templates": "Шаблоны",
  "bp.untitled.tpl": "Шаблон без названия",
  "bp.untitled.flow": "Поток без названия",
  "bp.mode.single": "Один",
  "bp.mode.rotator": "Ротация",
  "bp.startAt": "Старт",
  "bp.startAt.ph": "Выберите стартовый узел",
  "bp.commands": "Команды",
  "bp.undo": "Отменить изменение (⌘Z)",
  "bp.redo": "Повторить изменение (⌘⇧Z)",
  "bp.details.hide": "Скрыть детали",
  "bp.details": "Детали",
  "bp.saveAsTpl.hint": "Сохранить структуру потока как шаблон",
  "bp.saveAsTpl": "Сохранить как шаблон",
  "bp.fixFirst": "Сначала исправьте ошибки",
  "bp.saving": "Сохраняю…",
  "tpl.category": "Категория",
  "tpl.scope": "Доступ",
  "tpl.tags.ph": "Добавьте теги (например, health, geo-us)…",
  "tpl.desc.ph": "Что делает шаблон и когда его выбирать?",
  "bp.palette": "Палитра узлов",
  "bp.canvas": "Холст потока",
  "bp.empty.tpl": "Пустой шаблон",
  "bp.empty.flow": "Пустой поток",
  "bp.empty.tpl.body": "Выберите узел в палитре, чтобы начать собирать шаблон.",
  "bp.empty.flow.body": "Выберите узел в палитре, начните с рецепта или возьмите шаблон.",
  "bp.recipe": "Начать с рецепта",
  "bp.flowContext": "Контекст потока",
  "bp.routing": "Поведение маршрутизации",
  "bp.sticky": "Закрепить оффер",
  "bp.sticky.hint": "Первый выпавший посетителю оффер закрепляется: повторные визиты, клики по кнопке и все ветки ведут на него.",
  "bp.sticky.ttl": "Срок (часы)",
  "bp.sticky.ttl.hint": "По умолчанию 24 ч, максимум 30 дней.",
  "bp.rotation": "Ротация по времени",
  "bp.rotation.hint": "В пределах окна вернувшийся посетитель видит тот же ленд; после — прошлый ленд исключается и выпадает новый.",
  "val.missingLander": "Добавьте хотя бы один узел «Ленд» — потоку нечего показать.",
  "val.missingOffer": "Добавьте хотя бы один узел «Оффер» — потоку нечего монетизировать.",
  "val.branch.named": "Ветка «{trigger}»",
  "val.branch.any": "Ветка",
  "val.branch.pickTrigger": "Выберите, что открывает ветку: «Назад», попытка уйти, бездействие или конец страницы.",
  "val.branch.idle": "Ветка бездействия срабатывает через {min}–{max} секунд без действий.",
  "val.branch.incoming": "{name}: есть входящая связь — в ветку попадают только по триггеру.",
  "val.branch.default": "Ветка не может быть стартовым узлом — клик по рекламе начинает основной путь.",
  "val.branch.empty": "{name} никуда не ведёт — соедините её с лендами или офферами.",
  "val.branch.dup": "В потоке уже есть ветка «{trigger}» — одна ветка на триггер.",
  "val.unreachable": "{kind}: узел недостижим — от старта к нему нет пути.",
  "val.terminal": "{kind}: конечный узел, у него не может быть исходящих связей.",
  "val.mixed": "Нельзя смешивать связи с условиями и без. Выберите что-то одно.",
  "val.sum": "Сумма весов исходящих целей должна быть 100 (сейчас {sum}).",
  "val.cycle": "В потоке есть цикл. Связи не должны замыкаться.",
  "canvas.tb": "Сверху вниз",
  "canvas.vertical": "Вертикально",
  "canvas.lr": "Слева направо",
  "canvas.horizontal": "Горизонтально",
  "canvas.tidy.hint": "Расставить автоматически (ручные позиции сбросятся)",
  "canvas.tidy": "Упорядочить",
  "canvas.wireHint": "Потяните от нижней точки узла к верхней точке другого, чтобы соединить.",
  "canvas.dropHint": "Отпустите на верхней точке другого узла, чтобы соединить",
  "canvas.edge": "Связь",
  "canvas.noFilters": "В потоке пока нет фильтров — добавьте фильтр из палитры, чтобы поставить условие на связь.",
  "canvas.always": "Всегда (без условия)",
  "canvas.condHint": "Если задано, клик идёт по связи только когда фильтр выполнен.",
  "canvas.removeEdge": "Удалить связь",
  "canvas.newHere": "Новый узел здесь",
  "canvas.noRule": "без условия",
  "card.unbound": "Не выбрано",
  "card.noUrl": "нет адреса",
  "card.on": "по: {trigger}",
  "card.start.hint": "Стартовый узел — отсюда начинается маршрут клика",
  "card.disabled": "Выключен",
  "card.terminal.hint": "Конечный — без исходящих связей",
  "card.hasErrors": "Есть ошибки",
  "card.errorLabel": "Ошибка: {codes}",
  "card.invalid": "некорректно",
  "card.dropHere": "Отпустите связь здесь",
  "card.dragFrom": "Потяните отсюда к другому узлу, чтобы соединить",
  "card.fanout": "веток: {n} • Σ весов = {sum}",
  "edge.split": "{n}% сплита",
  "edge.if": "если {cond}",
  "vb.ok": "Поток в порядке",
  "vb.issues": "Мешает сохранить ошибок: {n}",
  "vb.error": "ОШИБКА",
  "ceb.title": "Холст потока упал",
  "ceb.unexpected": "Неожиданная ошибка сломала редактор.",
  "ceb.hint": "Сбросьте холст, чтобы попробовать снова. Изменения узлов сохранены в памяти и вернутся после сброса.",
  "ceb.reset": "Сбросить холст",
  "param.text": "Текст",
  "param.number": "Число",
  "param.title": "Параметры",
  "param.hint": "Задаются при применении шаблона. В узле ссылайтесь как",
  "param.add": "Добавить параметр",
  "param.empty": "Параметров пока нет. Кнопкой «+ новый параметр» в свойствах узла превратите привязку в параметр.",
  "param.remove": "Удалить параметр",
  "param.key": "Ключ",
  "param.kind": "Тип",
  "param.label": "Подпись",
  "param.default": "По умолчанию",
  "param.default.hint": "Запасное значение, если не задано",
  "cw.title": "Начать с шаблона",
  "cw.desc": "Готовые рецепты — сплит по гео, A/B-тесты, защита от ботов. Выберите, заполните поля и продолжайте редактировать.",
  "cw.none": "Шаблонов пока нет — создайте из любого потока кнопкой «Сохранить как шаблон».",
  "cw.curated": "Подборка",
  "cw.another": "Выбрать другой",
  "cw.noParams": "Параметров нет — шаблон применяется как есть.",
  "cw.use": "Применить шаблон",
  "aw.creating": "Создаю поток…",
  "aw.create": "Создать поток",
  "aw.review": "Проверка",
  "aw.next": "Далее",
  "aw.back": "Назад",
  "aw.noParams": "Параметры не нужны",
  "aw.noParams.hint": "Примените шаблон, чтобы создать поток как есть.",
  "aw.blueprint": "Шаблон",
  "aw.nodes": "узлов: {n}",
  "aw.step": "Шаг {i} из {n}",
  "aw.default": "По умолчанию:",
  "aw.ready": "Всё готово",
  "aw.ready.hint": "Проверьте значения ниже — с ними из шаблона будет создан поток.",
  "aw.unbound": "не задано",
  "aw.noParams.review": "У шаблона нет параметров — поток создаётся как есть.",
  "tc.noDesc": "Без описания.",
  "tc.actions": "Действия с шаблоном",
  "tc.edit": "Изменить шаблон",
  "tc.params": "параметров: {n}",
  "tc.apply": "Применить",
  "vt.current": "текущая",
  "vh.restored": "Восстановлена версия {v}",
  "vh.restoreFailed": "Не удалось восстановить",
  "vh.title": "История версий",
  "vh.desc": "Каждое сохранение — снимок шаблона. Восстановление добавляет новую версию сверху, так что откат тоже можно отменить.",
  "vh.restoring": "Восстанавливаю…",
  "vh.restoreV": "Восстановить v{v}",
  "vh.close": "Закрыть",
  "vh.timeline": "Версии",
  "vh.saving": "сохраняю…",
  "vh.none": "Версий пока нет",
  "vh.none.hint": "Первое сохранение создаст v1. До тех пор восстанавливать нечего.",
  "vh.diff": "Разница: v{v} → текущая",
  "vh.restore.hint": "Текущий шаблон сохраняется новой версией перед заменой, так что откат можно отменить.",
  "vh.note": "Комментарий к откату (необязательно)",
  "vh.note.ph": "например, откат теста после падения CTR",
  "vh.open": "Открыть историю версий",
  "vh.history": "История",
  "mini.graph": "Граф потока, узлов: {n}",
  "ctx.strict": "строго",
  "ctx.enabled": "Слой включён",
  "ctx.enabled.hint": "Если выключить, слой станет последним — следующие слои не подмешиваются.",
  "ctx.any": "любой",
  "ctx.unknown": "неизвестно",
  "ctx.csv": "значения через запятую",
  "ctx.addKey": "Добавить ключ",
  "ctx.fromSchema": "Из схемы",
  "ctx.customKey": "Свой ключ",
  "ctx.add": "Добавить",
  "ctx.schema": "Схема",
  "ctx.strictMode": "Строгий режим",
  "ctx.transform": "Преобразование контекста",
  "cmd.ph": "Команда или поиск узла…",
  "cmd.none": "Ничего не найдено.",
  "cmd.toggle": "Сменить направление раскладки",
  "cmd.goto": "Перейти к узлу",
  "cmd.setStart": "Сделать стартовым",
  "as.describeFirst": "Сначала опишите воронку",
  "as.none": "Помощник не предложил черновик — переформулируйте",
  "as.connect": "Сначала подключите {provider}",
  "as.openConnections": "Открыть интеграции",
  "as.applied": "Черновик применён — ⌘Z, чтобы отменить",
  "as.button": "Помощник",
  "as.title": "Помощник по потокам",
  "as.hint": "Опишите воронку своими словами — помощник набросает граф маршрутизации с местами под офферы и ленды, которые вы заполните потом.",
  "as.ph": "например, «мобильный трафик US — на основной оффер через прелендинг, боты — на белую страницу, остальные — на запасной оффер»",
  "as.again": "Ещё вариант",
  "as.draft": "Набросать поток",
  "as.untitled": "Черновик помощника",
  "as.issues": "В черновике незакрытых ошибок: {n} — они появятся на холсте после применения.",
  "as.ok": "Черновик проходит проверку — заполните места и сохраните.",
  "as.apply": "Применить черновик",
  "ubd.param": "Параметр",
  "ft.confirmArchive": "Архивировать «{name}»?",
  "ft.archived": "«{name}» в архиве",
  "ft.created": "Из шаблона создан поток «{name}»",
  "ft.createFailed": "Не удалось создать поток",
  "ft.eyebrow": "Шаблоны",
  "ft.title": "Шаблоны потоков",
  "ft.subtitle": "Готовые потоки с местами под ленд, оффер и страну. Примените шаблон — и через секунды у кампании готовый поток.",
  "ft.new": "Новый шаблон",
  "ft.search": "Поиск шаблонов по названию…",
  "ft.all": "Все",
  "ft.loadError": "Не удалось загрузить шаблоны",
  "ft.noMatch": "Подходящих шаблонов нет",
  "ft.empty": "Шаблонов потоков пока нет",
  "ft.noMatch.hint": "Измените запрос или сбросьте фильтры.",
  "ft.empty.hint": "Шаблон хранит структуру потока с именованными параметрами — новую кампанию можно запустить, не собирая маршрутизацию заново.",
  "ft.clear": "Сбросить фильтры",
  "ft.first": "Создать первый шаблон",
  "goals.unarchived": "«{key}» возвращена из архива",
  "goals.archived": "«{key}» в архиве",
  "goals.confirmDelete": "Удалить цель «{key}»? У прошлых конверсий ключ останется.",
  "goals.deleted": "Цель «{key}» удалена",
  "goals.inArchive": "в архиве",
  "goals.col.revenue": "Доход",
  "goals.col.primary": "Основная",
  "goals.col.multiple": "Повторы",
  "goals.unarchive": "Вернуть из архива",
  "goals.title": "Цели конверсий",
  "goals.subtitle": "Что считается конверсией в этом пространстве — ключи определяют разбор постбеков, дедупликацию, доход и метрики по целям в отчётах.",
  "goals.seed": "Добавить из пресета",
  "goals.presets": "Пресеты",
  "goals.seeded": "Добавлено целей из «{preset}»: {n}",
  "goals.seedFailed": "Не удалось добавить пресет",
  "goals.count": "целей: {n}",
  "goals.noPresets": "Пресетов нет",
  "goals.new": "Новая цель",
  "goals.loadError": "Не удалось загрузить цели",
  "goals.showArchived": "Показывать архивные",
  "goals.empty": "Целей пока нет. Добавьте пресет или создайте первую цель вручную.",
  "goals.updated": "Цель сохранена",
  "goals.created": "Цель создана",
  "goals.editTitle": "Цель · {key}",
  "goals.newTitle": "Новая цель конверсии",
  "goals.key.immutable": "Ключ не меняется — он записан в прошлых конверсиях.",
  "goals.key.new": "Ключ записывается в каждую конверсию и потом не меняется.",
  "goals.name.ph": "Депозит",
  "goals.revenue": "Считается доходом",
  "goals.revenue.hint": "Выплаты по этой цели идут в доход.",
  "goals.primary": "Основная цель",
  "goals.primary.hint": "Из неё считаются главные конверсии и CR (одна на пространство).",
  "goals.multiple": "Разрешить повторы",
  "goals.multiple.hint": "Несколько событий на клик (например, ребиллы).",
  "goals.create": "Создать цель",
  "goals.cat.registration": "Регистрация",
  "goals.cat.deposit": "Депозит",
  "goals.cat.rebill": "Ребилл",
  "goals.cat.sale": "Продажа",
  "goals.cat.lead": "Лид",
  "goals.cat.upsell": "Апсейл",
  "goals.cat.install": "Установка",
  "goals.cat.trial": "Пробный период",
  "goals.cat.custom": "Своя",
  "tm.placement": "Место вставки",
  "tm.updated": "Изменён",
  "tm.saved": "Сниппет сохранён",
  "tm.created": "Сниппет создан",
  "tm.deleted": "Сниппет удалён",
  "tm.saveFirstPublish": "Сначала сохраните сниппет, потом публикуйте.",
  "tm.published": "Сниппет опубликован",
  "tm.publishFailed": "Не удалось опубликовать",
  "tm.saveFirstTest": "Сначала сохраните сниппет, потом отправьте тест.",
  "tm.testSent": "Тестовое событие отправлено — {detail}",
  "tm.testFailed": "Тестовое событие не прошло: {detail}",
  "tm.testError": "Не удалось отправить тест",
  "tm.title": "Тег-менеджер",
  "tm.subtitle": "Сниппеты кода, которые вставляются в ленды, по источнику трафика или перед редиректом. Условия — тот же движок выражений, что у правил.",
  "tm.new": "Новый сниппет",
  "tm.loadError": "Не удалось загрузить сниппеты",
  "tm.allScopes": "Все области",
  "tm.enabledOnly": "Только включённые",
  "tm.empty": "Сниппетов пока нет.",
  "tm.edit": "Сниппет",
  "tm.desc": "Сниппет срабатывает в выбранном месте. Условия сужают, кому он показывается.",
  "tm.deleting": "Удаляю…",
  "tm.target": "Объект",
  "tm.conditions": "Условия (выражение)",
  "tm.conditions.ph": "например, country == \"US\" && device == \"mobile\"",
  "tm.conditions.hint": "Оставьте пустым, чтобы срабатывал всегда. Проверяется по запросу в момент срабатывания.",
  "tm.code": "Код",
  "tm.enabled.hint": "Выключенный сниппет хранится, но не вставляется.",
  "tm.consent": "Нужное согласие (Consent Mode v2)",
  "tm.consent.hint": "Срабатывает, только если посетитель дал согласие (granted) по каждой отмеченной категории.",
  "tm.publishedV": "Опубликован v{v}",
  "tm.draftV": "Черновик v{v}",
  "tm.sending": "Отправляю…",
  "tm.sendTest": "Отправить тестовое событие",
  "tm.publishing": "Публикую…",
  "tm.publish": "Опубликовать",
  "tm.dest": "Серверный получатель",
  "tm.dest.hint": "Постбек-сниппет срабатывает с сервера через выбранный адаптер. Секреты (api_secret_ref, access_token_ref) — это ключи AWS Secrets Manager, а не сами секреты, например",
  "tm.mappings": "Сопоставление полей (JSON)",
  "tm.mappings.array": "Массив вида",
  "tm.mappings.hint": "Макросы подставляются в момент срабатывания. Стандартные персональные поля (em, ph, fn, ln, ge, ct, st, zp, country, external_id) хэшируются SHA-256 автоматически; идентификаторы клика (fbc, fbp) уходят как есть.",
  "tm.http.hint": "«Свой HTTP» берёт адрес отправки из поля «Код». Больше ничего настраивать не нужно.",
  "tm.status.draft": "Черновик",
  "tm.status.published": "Опубликован",
  "tm.status.archived": "В архиве",
  "tm.dest.http": "Свой HTTP",
  "tm.dest.ga4": "Google Analytics 4 (MP)",
  "tm.dest.tiktok": "TikTok Events API",
  "tm.kind.gtm": "GTM",
  "tm.kind.pixel": "Пиксель",
  "tm.kind.postback": "Постбек",
  "tm.kind.js": "Свой JS",
  "tm.kind.html": "Свой HTML",
  "tm.place.head": "В head",
  "tm.place.bodyTop": "Начало body",
  "tm.place.bodyBottom": "Конец body",
  "tm.place.beforeRedirect": "Перед редиректом",
  "ipi.enterCidr": "Введите CIDR (например, 203.0.113.0/24)",
  "ipi.added": "Исключение добавлено",
  "ipi.addFailed": "Не удалось добавить исключение",
  "ipi.title": "IP-данные",
  "ipi.subtitle": "Регион, прокси/VPN/датацентр, ASN и репутация — из всех источников в один MMDB, который край читает локально. Пересобирается по расписанию, публикуется на все края и подхватывается без похода на origin.",
  "ipi.rebuildStarted": "Пересборка запущена",
  "ipi.rebuildFailed": "Не удалось запустить пересборку",
  "ipi.feeds": "Источники данных",
  "ipi.feeds.error": "Не удалось загрузить источники: {error}",
  "ipi.unknownError": "неизвестная ошибка",
  "ipi.feeds.none": "Источников нет.",
  "ipi.col.source": "Источник",
  "ipi.col.freshness": "Свежесть",
  "ipi.col.lastSuccess": "Последний успех",
  "ipi.col.rows": "Строк",
  "ipi.failing": "падает",
  "ipi.servingLast": "(отдаём последние хорошие данные)",
  "ipi.fresh": "свежие",
  "ipi.notRun": "не запускался",
  "ipi.stale": "устарели",
  "ipi.configure.hint": "Настроить токен / адрес",
  "ipi.configure": "настроить",
  "ipi.setup": "подключить",
  "ipi.on": "{source} включён",
  "ipi.off": "{source} выключен",
  "ipi.disableHint": "Выключение источника вступает в силу со следующей пересборки.",
  "ipi.overrides": "Ручные исключения",
  "ipi.overrides.hint": "Задать классификацию для CIDR — она важнее данных источников при пересборке. Рычаг на случай, если сеть определена неверно.",
  "ipi.classification": "Классификация",
  "ipi.reason": "Причина",
  "ipi.reason.ph": "зачем это исключение",
  "ipi.noOverrides": "Исключений нет.",
  "ipi.expired": "истекло",
  "ipi.expires": "истекает",
  "ipi.deleted": "Исключение удалено",
  "ipi.versions": "История версий MMDB",
  "ipi.noBuilds": "Сборок нет.",
  "ipi.col.built": "Собрано",
  "ipi.col.version": "Версия",
  "ipi.col.records": "Записей",
  "ipi.col.size": "Размер",
  "ipi.col.published": "Опубликовано",
  "ipi.notPublished": "не опубликовано",
  "ipi.configured": "{source} настроен и включён",
  "ipi.configureFailed": "Не удалось настроить",
  "ipi.dialog.hint": "Хранится в зашифрованном виде. Настройка источника заодно включает его — он отработает при следующей пересборке.",
  "ipi.saveEnable": "Сохранить и включить",
  "ipi.rebuilding": "Идёт пересборка…",
  "ipi.lastFailed": "Последняя пересборка упала",
  "ipi.upToDate": "Данные актуальны",
  "ipi.loading": "Загрузка…",
  "ipi.started": "Запущена",
  "ipi.lastRun": "Последний запуск",
  "ipi.noRebuild": "Пересборок ещё не было",
  "ipi.rebuildNow": "Пересобрать сейчас",
  "ipi.nextRun": "Следующий запуск",
  "ipi.cadence": "Периодичность",
  "ipi.every": "каждые {d}",
  "ipi.publishedVersion": "Опубликованная версия",
  "ipi.sourcesFailed": "упало источников: {n}",
  "ipi.disagreements": "расхождений по гео: {n}",
  "ipi.in.soon": "через <1 мин",
  "ipi.in.m": "через {n} мин",
  "ipi.in.h": "через {n} ч",
  "ipi.in.d": "через {n} дн",
  "ipi.dur.s": "{s} с",
  "ipi.dur.ms": "{m} мин {s} с",
  "ipi.dur.d": "{n} дн",
  "ipi.dur.h": "{n} ч",
  "ipi.dur.m": "{n} мин",
  "ipi.cls.none": "нет (чистая сеть)",
  "ipi.cls.vpn": "VPN",
  "ipi.cls.public_proxy": "публичный прокси",
  "ipi.cls.residential_proxy": "резидентный прокси",
  "ipi.cls.tor": "Tor",
  "ipi.cls.datacenter": "датацентр",
  "ipi.cls.unknown": "неизвестно",
  "ipi.f.ipinfo.ph": "вставьте токен ipinfo.io",
  "ipi.f.ipinfo.hint": "Бесплатно на ipinfo.io — набор Lite (гео + ASN).",
  "ipi.f.ip2l.hint": "Ваша ссылка на скачивание LITE (в ней уже есть токен).",
  "ipi.f.maxmind.hint": "Адрес, отдающий сам .mmdb (не tar.gz).",
  "edge.bareOrigin": "Без края (origin)",
  "edge.mmdb.object": "хранилище объектов ({key})",
  "edge.mmdb.file": "локальный файл ({path})",
  "edge.mmdb.headers": "заголовки края (X-Ip-*)",
  "edge.title": "Край",
  "edge.subtitle": "Где работают кампании, какие ревизии опубликованы и дошли ли последние изменения до развёртывания.",
  "edge.pub": "Публикации кампаний",
  "edge.pub.hint": "«Опубликовано» — включённая ревизия. «Видно» — последняя ревизия, которую подтвердил отвечающий узел; это не подтверждение по всем точкам.",
  "edge.pub.error": "Статус публикаций недоступен",
  "edge.pub.none": "Развёртываний пока нет.",
  "edge.col.path": "Путь кампании / развёртывание",
  "edge.col.desired": "Нужно",
  "edge.col.observed": "Видно",
  "edge.pending": "Ожидает",
  "edge.checkQueued": "Проверка публикации поставлена в очередь",
  "edge.checkFailed": "Не удалось поставить проверку в очередь",
  "edge.retry": "Повторить",
  "edge.delivery": "Доставка событий и лидов",
  "edge.delivery.hint": "Принятые события надёжно хранятся, пока доставка повторяется. Пока проекции в очереди, отчёты могут отставать. Обновляется каждые 15 секунд.",
  "edge.delivery.error": "Статус доставки недоступен",
  "edge.delivery.none": "Данных о доставке нет.",
  "edge.col.pendingEvents": "Событий в очереди",
  "edge.col.pendingLeads": "Лидов в очереди",
  "edge.col.attention": "Требует внимания",
  "edge.col.pendingProj": "Проекций в очереди",
  "edge.col.oldest": "Самое старое",
  "edge.col.lastProj": "Последняя проекция",
  "edge.deadFailed": "событий: {events} · лидов: {leads}",
  "edge.topology": "Топология",
  "edge.provider": "Провайдер",
  "edge.ipiSource": "Источник IP-данных",
  "edge.hotReload": "Перечитывание MMDB",
  "edge.kvPublish": "Публикация конфигурации края (CF KV)",
  "edge.jscSecret": "Секрет JS-проверки",
  "edge.latestMmdb": "Последний опубликованный MMDB",
  "edge.records": "записей: {n}",
  "edge.built": "собран {when}",
  "edge.publishedAt": "опубликован {when}",
  "edge.notPublished": "ещё не опубликован на край",
  "edge.propagation": "Распространение IP-данных",
  "edge.propagation.hint": "Подтверждает, что свежий MMDB дошёл до всех краёв — регион и прокси определяются локально в каждом регионе, без похода на origin.",
  "edge.plane.cf": "Край Cloudflare (isolate)",
  "edge.plane.origin": "Хранилище origin (Go-край)",
  "edge.objectOff": "IP-данные из хранилища не включены",
  "edge.domainSync": "Синхронизация конфигурации доменов",
  "edge.domainSync.none": "Ни один домен ещё не синхронизировал конфигурацию края.",
  "edge.lastSynced": "Синхронизирован",
  "edge.failed": "ошибка",
  "edge.synced": "синхронизирован",
  "edge.resyncQueued": "Пересинхронизация {domain} поставлена в очередь",
  "edge.resyncFailed": "Не удалось пересинхронизировать",
  "edge.resync": "Пересинхронизировать",
  "edge.b.notConfigured": "не настроен",
  "edge.b.tracks": "следует за последней",
  "edge.b.inSync": "совпадает",
  "edge.b.lagging": "отстаёт",
  "edge.configured": "настроено",
  "edge.notSet": "не задано",
  "ov.st.bound": "привязан",
  "ov.st.skipped": "пропущен",
  "ov.st.refused": "отклонён",
  "ov.st.binding": "привязывается",
  "ov.st.queued": "в очереди",
  "ov.st.failed": "ошибка",
  "ov.st.diverged": "ответ отличается",
  "ov.st.timeout": "таймаут",
  "ov.st.running": "идёт",
  "ov.st.halted": "остановлен",
  "ov.st.completed": "завершён",
  "ov.toOrigin": "{name}: на свой origin",
  "ov.backOnWorker": "{name}: снова через Worker",
  "ov.allToOrigin": "Все overlay-домены → origin",
  "ov.globalOff": "Общий рубильник выключен",
  "ov.killFailed": "Рубильник не сработал: {error}",
  "ov.kills": "Рубильники",
  "ov.kills.hint": "Отправить overlay-домен — или все — прямо на его origin. Срабатывает за ~70 с. Прямые домены не затрагиваются.",
  "ov.global.on": "Общий рубильник ВКЛ — выключить",
  "ov.global.off": "Общий рубильник: все overlay → origin",
  "ov.kills.error": "Рубильники недоступны",
  "ov.domain.ph": "domain.example — на свой origin",
  "ov.switchOrigin": "На origin",
  "ov.confirmAll": "Отправить все overlay-домены на их origin?",
  "ov.confirmAll.hint": "Worker отойдёт в сторону на всех overlay-доменах за ~70 с. Прямые домены не затрагиваются.",
  "ov.confirmAll.ok": "Все overlay → origin",
  "ov.rollout.error": "Волна недоступна",
  "ov.waveLine": "волна {i} / {n} · по {size} · пауза {pause} с",
  "ov.stopping": "Останавливаю…",
  "ov.stop": "Остановить",
  "ov.wave": "Волна",
  "ov.originBeforeAfter": "Origin до → после",
  "ov.started": "Волны запущены",
  "ov.refused": "Запуск отклонён: {error}",
  "ov.rollouts": "Волны",
  "ov.rollouts.hint": "Ставит Worker перед доменами волнами. Для каждого домена: vibe-domains подтверждает, что зона его примет, origin отвечает на /robots.txt, overlay-домен привязывается, и origin спрашивается снова через Worker. Неудачная или запоздалая привязка либо другой ответ останавливают волны и отправляют этот домен на origin. Канарейка 5 → 50 → остальные.",
  "ov.domains.ph": "по домену в строке\nсначала малотрафиковые",
  "ov.perWave": "В волне",
  "ov.pause": "Пауза, с",
  "ov.bindTimeout": "Таймаут привязки, с",
  "ov.start": "Запустить ({n})",
  "ov.confirmStart": "Запустить волны на {n} доменов?",
  "ov.confirmStart.hint": "По {size} в волне, {pause} с между волнами. Упавший или ответивший иначе домен останавливает волны и возвращается на origin.",
  "ov.confirmStart.ok": "Запустить волны",
  "ov.rollouts.error": "Волны недоступны",
  "ov.summary": "доменов: {n} · привязано {bound} · отклонено {refused} · {who}",
  "ov.title": "Overlay",
  "ov.subtitle": "Домены, где всё, что не обслуживает трекер, по-прежнему отдаёт их собственный origin.",
  "fw.s.tor_exit": "Выход Tor",
  "fw.s.tor_exit.desc": "IP — известный выход Tor.",
  "fw.s.residential_proxy": "Резидентный прокси",
  "fw.s.residential_proxy.desc": "Ротируемая сеть резидентных прокси.",
  "fw.s.public_proxy": "Публичный прокси",
  "fw.s.public_proxy.desc": "Открытый / публичный HTTP(S)-прокси.",
  "fw.s.datacenter_ip": "IP датацентра",
  "fw.s.datacenter_ip.desc": "Диапазон хостинга, а не домашнего провайдера.",
  "fw.s.vpn": "VPN",
  "fw.s.vpn.desc": "Выход коммерческого VPN.",
  "fw.s.hosting_asn": "ASN хостинга",
  "fw.s.hosting_asn.desc": "ASN помечен как хостинг/облако.",
  "fw.s.ua_anomaly": "Аномалия UA",
  "fw.s.ua_anomaly.desc": "User-Agent битый или не браузерный.",
  "fw.s.headless": "Headless",
  "fw.s.headless.desc": "Отпечаток headless-браузера / автоматизации.",
  "fw.s.header_anomaly": "Аномалия заголовков",
  "fw.s.header_anomaly.desc": "Градуированный: доля проверок заголовков браузера, которые запрос не прошёл.",
  "fw.s.ja4_ua_mismatch": "JA4 ↔ UA не совпадают",
  "fw.s.ja4_ua_mismatch.desc": "TLS-отпечаток не соответствует заявленному браузеру.",
  "fw.s.country_asn_mismatch": "Страна ↔ ASN не совпадают",
  "fw.s.country_asn_mismatch.desc": "Страна по гео расходится с регистрацией ASN.",
  "fw.s.ip_reputation": "Репутация IP",
  "fw.s.ip_reputation.desc": "Умножается на оценку репутации из источника (0..1).",
  "fw.s.velocity": "Частота",
  "fw.s.velocity.desc": "Умножается на клики за 60 с относительно точки насыщения.",
  "fw.s.has_fbclid": "Есть fbclid",
  "fw.s.has_fbclid.desc": "Этот параметр ставит редирект самого Facebook, поэтому он — признак настоящего клика. Вес отрицательный намеренно.",
  "fw.s.referrer_spoof": "Подделка реферера",
  "fw.s.referrer_spoof.desc": "Реферер называет сеть, к которой id клика не относится.",
  "fw.g.proxy": "Прокси и анонимность",
  "fw.g.client": "Облик клиента",
  "fw.g.graded": "Градуированные",
  "fw.g.human": "Похоже на человека",
  "fw.g.other": "Прочее",
  "fw.thresholds.invalid": "Порог «подозрительный» должен быть ниже порога «бот» (0–100).",
  "fw.saved": "Каталог скоринга сохранён",
  "fw.title": "Настройка каталога скоринга",
  "fw.scope.global": "Правится общий каталог по умолчанию (для всей платформы).",
  "fw.scope.ws": "Правится каталог этого пространства (он заменяет общий).",
  "fw.scope.inherit": "Пространство использует общий каталог — сохранение создаст собственный.",
  "fw.origin": "Источник:",
  "fw.lastBy": "последним менял {who}",
  "fw.thresholds": "Пороги классификации",
  "fw.suspiciousAt": "Подозрительный от",
  "fw.botAt": "Бот от",
  "fw.thresholds.below": "Порог «подозрительный» должен быть ниже порога «бот».",
  "fw.reset": "Вернуть по умолчанию",
  "fw.save": "Сохранить каталог",
  "fw.o.default": "поставочный по умолчанию",
  "fw.o.manual": "ручная правка",
  "fw.o.feedback": "подстроен по обратной связи",
  "fw.unavailable": "недоступен",
  "fw.shadow": "тень",
  "fw.off": "выкл",
  "fw.default": "по умолчанию {w}",
  "fw.saturates": "насыщение при",
  "fw.shadow.hint": "Считается и пишется в трейс полностью, но даёт 0. Так сигнал зарабатывает вес, прежде чем влиять на маршрут.",
  "fw.disabled": "выключен",
  "fw.disabled.hint": "Не считается вовсе. Прошлые трейсы с ним остаются читаемыми.",
  "fw.noTraffic": "За выбранный период нет оценённого трафика для предпросмотра.",
  "fw.human": "Люди {p}",
  "fw.suspicious": "Подозрительные {p}",
  "fw.bot": "Боты {p}",
  "rep.any": "любой",
  "rep.st.shadow": "тень",
  "rep.st.active": "активен",
  "rep.st.retracted": "отозван",
  "rep.st.allowlisted": "в белом списке",
  "rep.ty.net": "сеть",
  "rep.ty.ip": "IP",
  "rep.ty.ua": "хэш UA",
  "rep.ty.visitor": "посетитель",
  "rep.entries": "записей: {n}",
  "rep.empty": "В хранилище репутации пока пусто.",
  "rep.empty.hint": "Детекторы каждые пять минут проходят по нашему трафику. Всё найденное попадает в тень — видно здесь, но ни на что не влияет.",
  "rep.entity": "Объект",
  "rep.detector": "Детектор",
  "rep.confidence": "Уверенность",
  "rep.evidence": "Доказательства",
  "rep.lastSeen": "Последний раз",
  "rep.st.shadow.hint": "Видно в каждом трейсе решения, но ни на что не влияет.",
  "rep.st.active.hint": "Влияет на бот-скор.",
  "rep.st.retracted.hint": "Человек отметил ошибку. Больше не учитывается.",
  "rep.st.allowlisted.hint": "Человек решил, что здесь мы всегда будем ошибаться.",
  "rep.reasonRequired": "Нужна причина — изменение, которое потом никто не объяснит, нельзя безопасно отменить.",
  "rep.changed": "Теперь: {status}",
  "rep.summary": "уверенность {p} · {detector} · {status}",
  "rep.noDetector": "без детектора",
  "rep.noObs": "Наблюдений нет.",
  "rep.audit": "История изменений",
  "rep.by": "— {who}",
  "rep.change": "Изменить вердикт",
  "rep.reason.ph": "Почему? (обязательно — без этого изменение потом не откатить)",
  "rep.promote": "Сделать активным",
  "rep.retract": "Отозвать",
  "rep.allowlist": "В белый список",
  "rep.actions.hint": "«Отозвать» отменяет один неверный вердикт. «В белый список» — значит, здесь мы всегда будем ошибаться: детекторы продолжают наблюдать, данные помогают их оценивать, но в скор это не идёт.",
  "sc.empty": "За этот период ни один детектор ещё ничего не отметил.",
  "sc.empty.hint": "Детекторы работают каждые пять минут и складывают находки в тень. Ничего не блокируется, пока детектор не заслужит повышение здесь.",
  "sc.baseline": "Базовая конверсия:",
  "sc.baseline.hint": "на {n} кликов. Если отмеченный детектором трафик конвертит не хуже — он находит клиентов, а не ботов.",
  "sc.entities": "Объектов",
  "sc.flagged": "Отмечено",
  "sc.share": "Доля",
  "sc.converted": "Сконвертило",
  "sc.cr": "CR",
  "sc.retracted": "Отозвано",
  "sc.verdict": "Вывод",
  "sc.v.thin": "мало данных",
  "sc.v.thin.why": "Меньше 200 отмеченных кликов. На таком объёме нельзя обосновать ни повышение, ни понижение.",
  "sc.v.retracted": "отозвано людьми: {n}",
  "sc.v.retracted.why": "Человек уже посмотрел на результат детектора и отметил ошибку. Это прямее любой конверсии.",
  "sc.v.customers": "отмечает клиентов",
  "sc.v.customers.why": "Отмеченный трафик конвертит {rate} при базе {base}. Детектор находит не ботов.",
  "sc.v.promote": "можно повышать",
  "sc.v.promote.why": "Отмеченный трафик конвертит {rate} — сильно ниже базы {base}. Перед повышением подождите 7 дней.",
  "sc.v.watch": "наблюдать дальше",
  "sc.v.watch.why": "Отмеченный трафик конвертит ниже базы, но не решительно. Нужно больше времени.",
  "int.cf.tagline": "DNS-зоны, проксируемые записи, SSL и отдача с края для ваших трекинговых доменов.",
  "int.cf.setup": "Создайте один API-токен с правами: Zone:Edit, DNS:Edit, SSL and Certificates:Edit (DNS + SSL), Workers KV Storage:Edit + Workers Routes:Edit + Workers Scripts:Read (отдача с края). ID аккаунта — справа на странице Overview любой зоны. Для самой быстрой отдачи по миру добавьте ниже доступ к R2.",
  "int.f.apiToken": "API-токен",
  "int.f.accountId": "ID аккаунта",
  "int.f.accountId.hint": "Нужен для отдачи с края (Workers KV и маршруты живут на уровне аккаунта).",
  "int.f.zoneId": "ID зоны",
  "int.f.zoneId.ph": "(необязательно) зона для своих хостнеймов",
  "int.f.zoneId.hint": "Нужен только для подключения внешних доменов через CF for SaaS.",
  "int.f.r2key.ph": "(необязательно) ключ доступа R2 S3",
  "int.f.r2key.hint": "R2 → Manage R2 API Tokens → Object Read & Write. Ленды отдаются из всех точек присутствия (~15 мс), а не с origin. Адрес берётся из ID аккаунта.",
  "int.f.r2secret.ph": "(необязательно) секрет R2 S3",
  "int.f.r2secret.hint": "Пара к ключу доступа R2 выше.",
  "int.f.r2bucket.hint": "Бакет, который читает Worker края. По умолчанию edge-pages.",
  "int.or.tagline": "Помощники для правил оповещений и потоков.",
  "int.or.setup": "Создайте API-ключ на openrouter.ai/keys. Модель можно закрепить — по умолчанию платформа берёт быструю и недорогую.",
  "int.f.apiKey": "API-ключ",
  "int.f.model": "Модель",
  "int.cat.ai": "ИИ",
  "int.st.healthy": "Работает",
  "int.st.degraded": "С перебоями",
  "int.st.failing": "Не работает",
  "int.st.disabled": "Выключено",
  "conn.probeFailed": "проверка не прошла",
  "conn.updated": "Подключение {provider} обновлено",
  "conn.platformDefault": "По умолчанию для платформы",
  "conn.wsName": "{provider} — пространство",
  "conn.connected": "{provider} подключён",
  "conn.connectTitle": "Подключить {provider}",
  "conn.platform.hint": "Общий запасной вариант для всех пространств без своего подключения. Только для админов платформы.",
  "conn.docs": "Документация провайдера",
  "conn.encrypted": "Доступы хранятся зашифрованными (AES-256-GCM) и никогда не отдаются в браузер.",
  "conn.verified": "Подключение проверено — доступы работают.",
  "conn.fillIn": "Заполните: {fields}",
  "conn.probe.hint": "Проверить провайдера с этими доступами",
  "conn.testing": "Проверяю…",
  "conn.test": "Проверить подключение",
  "conn.connect": "Подключить",
  "conn.optional": "(необязательно)",
  "conn.replace": "Заменить",
  "conn.newValue.ph": "новое значение (если не трогать, останется сохранённое)",
  "conn.wsConnection": "Подключение пространства",
  "conn.fallback": "общее подключение платформы",
  "conn.usingShared": "Используется общий аккаунт {provider} платформы.",
  "conn.override": "Подключить свой",
  "conn.notConfigured": "Не настроено",
  "conn.noDefault": "Общего подключения нет — пространства без своего получат ошибку.",
  "conn.setDefault": "Задать общее",
  "conn.ok": "{label}: подключение работает",
  "conn.removedFallback": "Удалено — теперь пространство использует {fallback}.",
  "conn.removed": "Подключение удалено.",
  "conn.checked": "проверено {when}",
  "conn.neverTested": "ещё не проверялось",
  "conn.probeStored": "Проверить сохранённые доступы",
  "conn.testShort": "Проверить",
  "conn.editCreds": "Изменить доступы",
  "conn.remove": "Удалить подключение",
  "conn.sure": "Точно?",
  "conn.title": "Интеграции",
  "conn.subtitle": "Подключите пространство к Cloudflare и OpenRouter. Доступы хранятся зашифрованными, принадлежат вашему пространству, а без своего аккаунта используется общий аккаунт платформы.",
  "conn.count": "подключено {n}/{total}",
  "conn.admin.hint": "Вы можете менять общие подключения платформы, которые используют все пространства.",
  "conn.admin": "Админ платформы",
  "conn.loadError": "Не удалось загрузить интеграции",
  "mac.click": "Клик",
  "mac.campaign": "Кампания и выплата",
  "mac.traffic_source": "Источник трафика",
  "mac.lander_offer": "Ленд и оффер",
  "mac.device": "Устройство и UA",
  "mac.geo": "Гео и язык",
  "mac.network": "Сеть",
  "mac.tracking_field": "Поля трекинга",
  "mac.deeplink": "Диплинк",
  "mac.custom": "Свои",
  "tfm.empty": "Поля трекинга ещё не сопоставлены. Нажмите «Добавить поле» ниже, чтобы привязать макрос источника к месту trackingField.",
  "tfm.add": "Добавить поле",
};
